import styled from 'styled-components';

/**
 * @deprecated
 * Use @r1-frontend/ui-react/components/svg instead
 */
const Icon = styled.div`
    display: inline-block;
    font-family: 'icomoon' !important;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    text-decoration: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: ${props => props.fontSize ? props.fontSize : 'inherit'};
    color: ${props => props.color || 'black'};
    &::before {
        content: ${props => `"${props.content}"`};
    }
`;

export default Icon;
